import { get as _get } from 'lodash';
import { v4 as uuid } from 'uuid';

import { CreateAutoServiceRequest, CreateRentalRequest } from '../model/create-auto-service-request';
import { CreatePlnarProjectPayload, CreateServicePayload } from '../types/type';

export async function createService(
  urlKey: string,
  sessionId: string,
  custKey: string,
  postBody: CreateServicePayload
) {
  try {
    const headers = new Headers();
    headers.append('urlid', urlKey);
    headers.append('afe-session-id', sessionId);
    headers.append('Authorization', 'Bearer ' + custKey);
    headers.append('content-type', 'application/json');
    headers.append('afe-trace-id', uuid());

    const URI = `${process.env['NX_DCV2_API_BASE_URL']}${postBody.claimNumber}/createpropertyservices`;
    const response = await fetch(URI, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(postBody),
    });
    if (response.status >= 200 && response.status <= 299) {
      const responseData = await response.json();
      if (responseData.response.code === 200) {
        return responseData;
      } else {
        return null;
      }
    } else {
      return null;
    }
  } catch (error) {
    return null;
  }
}

export async function createPlnar(
  urlKey: string,
  sessionId: string,
  custKey: string,
  postBody: CreatePlnarProjectPayload
) {
  try {
    const headers = new Headers();
    headers.append('urlid', urlKey);
    headers.append('afe-session-id', sessionId);
    headers.append('Authorization', 'Bearer ' + custKey);
    headers.append('content-type', 'application/json');
    headers.append('afe-trace-id', uuid());

    const URI = `${process.env['NX_DCV2_API_BASE_URL']}${postBody.claimNumber}/plnarupload`;
    const response = await fetch(URI, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(postBody),
    });
    if (response.status >= 200 && response.status <= 299) {
      const responseData = await response.json();
      if (responseData.response) {
        return responseData;
      } else {
        return null;
      }
    } else {
      return null;
    }
  } catch (error) {
    return null;
  }
}

export async function createAutoService(
  urlKey: string,
  sessionId: string,
  custKey: string,
  postBody: CreateAutoServiceRequest
) {
  try {
    const headers = new Headers();
    headers.append('urlid', urlKey);
    headers.append('afe-session-id', sessionId);
    headers.append('Authorization', 'Bearer ' + custKey);
    headers.append('content-type', 'application/json');
    headers.append('afe-trace-id', uuid());

    const URI = `${process.env['NX_DCV2_API_BASE_URL']}${postBody.claim.claimNumber}/drps`;
    const response = await fetch(URI, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(postBody),
    });
    const responseData = await response.json();
    const { statusCode } = responseData;
    const { error } = responseData;
    const { message } = responseData;

    if (_get(responseData, 'response.status.code', '') === 200) {
      return responseData;
    } else {
      return { error, statusCode, message };
    }
  } catch (error) {
    console.log('createAutoService:error', error);
    return error;
  }
}

export async function createRentalService(
  urlKey: string,
  sessionId: string,
  custKey: string,
  claimNumber: string,
  postBody: CreateRentalRequest
) {
  try {
    const headers = new Headers();
    headers.append('urlid', urlKey);
    headers.append('afe-session-id', sessionId);
    headers.append('Authorization', 'Bearer ' + custKey);
    headers.append('content-type', 'application/json');
    headers.append('afe-trace-id', uuid());

    const URI = `${process.env['NX_DCV2_API_BASE_URL']}${claimNumber}/rentals`;
    const response = await fetch(URI, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(postBody),
    });
    if (response.status >= 200 && response.status <= 299) {
      const responseData = await response.json();
      if (responseData.response.status.code === 200) {
        return responseData;
      } else {
        return null;
      }
    } else {
      return null;
    }
  } catch (error) {
    return null;
  }
}
